import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const FormContainer = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;
  `}
`

export const TitleSection = styled(Box)`
  ${() => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  `}
`

export const TitleBox = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  `}
`

export const TitleText = styled.h3`
  ${() => css`
    margin: 0;
    font-size: 1rem;
    color: #2d3748;
    font-weight: 600;
  `}
`

export const AccountCodeText = styled(Box)`
  ${() => css`
    font-size: 0.875rem;
    color: #718096;
    margin-left: 1.75rem;
  `}
`

export const WarningBanner = styled(Box)`
  ${() => css`
    width: 100%;
    padding: 0.75rem 1rem;
    background-color: #fffbeb;
    border: 1px solid #f59e0b;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
  `}
`

export const WarningText = styled.p`
  ${() => css`
    margin: 0;
    font-size: 0.875rem;
    color: #92400e;
    line-height: 1.5;
  `}
`

export const ContentGrid = styled(Box)`
  ${() => css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    width: 100%;
    align-items: flex-end;
  `}
`

export const LeftContent = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  `}
`

export const ItemDescription = styled(Box)`
  ${() => css`
    font-size: 0.875rem;
    font-weight: 500;
    color: #2d3748;
  `}
`

export const ItemAccountCode = styled(Box)`
  ${() => css`
    font-size: 0.8125rem;
    color: #718096;
  `}
`
